import type { RootState } from 'app'
import { createSelector } from '@reduxjs/toolkit'
import { getNonEmptyValuesObject } from 'shared/utils'
import { ContractorFilters } from 'shared/types'

const getContractorsState = (state: RootState) => state.Contractors

export const getFilters = createSelector(
  getContractorsState,
  state => getNonEmptyValuesObject(state.filters) as ContractorFilters
)
